import {
  buildDerivedFields,
  normalizeSubscriptionPaymentMethod,
} from './subscriptionStatus';

export const mapJussubSubscription = (data) => {
  const { subscription } = data;
  const planAmount = subscription.plan?.amount ?? null;
  const chargedAmount = subscription.amount ?? planAmount;
  const paymentMethod = normalizeSubscriptionPaymentMethod(
    subscription.paymentMethod,
  );
  const { next_charge_date, ...derivedStatus } = buildDerivedFields({
    rawStatus: subscription.status,
    currentPeriodEnd: subscription.cycleEndDate,
    paymentMethod,
  });

  const addons = (subscription.addons ?? []).map((addon) => ({
    id: addon.id,
    name: addon.name,
    amount: addon.amount,
    unitPrice: addon.unitPrice,
    itemCount: addon.itemCount,
    pendingRemoval: !!addon.pendingRemoval,
    removalEffectiveAt: addon.removalEffectiveAt,
    canReactivate: !!addon.canReactivate,

  }));

  const coupons = (subscription.coupons ?? []).map((coupon) => ({
      id: coupon.id,
      name: coupon.name ?? coupon.code,
      expiresAt: coupon.expiresAt,
  }));

  return {
    success: true,
    client_id: data.client_id,
    id_client_jussub: data.id_client_jussub,
    plan_details: {
      name: subscription.plan?.name ?? null,
      amount: planAmount ?? chargedAmount,
      periodicity: subscription.plan?.cycleDays ?? null,
      gateway_id: null,
      plan_type: null,
    },
    info: {
      status: subscription.status,
      plan: subscription.plan?.name ?? null,
      plan_amount: planAmount ?? chargedAmount,
      charged_amount: chargedAmount,
      current_period_start: subscription.cycleStartDate,
      current_period_end: subscription.cycleEndDate,
      payment_method: paymentMethod,
      coupon: subscription.coupons?.[0]?.code ?? null,
      provider: 'jussub',
      latest_update: subscription.updatedAt,
      subscription_id: subscription.id,
      next_charge_date,
      addons,
      coupons,
    },
    ...derivedStatus,
  };
};
